// extracted by mini-css-extract-plugin
module.exports = {"tile":"NestedRow_tile__3IZGY","name":"NestedRow_name__2DqSy"};